<template>

  <ValidationObserver ref="form" v-slot="{ handleSubmit }">
    <form v-can:any="['view-customer']" @submit.prevent="handleSubmit(onClickPasswordChange)" autocomplete="off">
      <vx-card :title="''" :titleColor="customerStatusColorFactory(form.status_id)" class="my-8">
        <template v-can:any="['edit-customer']" v-if="form.status_id === 5" slot="actions">
          <vs-button  @click="submitCustomerConfirm" class="mr-4" color="primary" type="filled">Submit</vs-button>
        </template>
        <div class="vx-row mb-3">
          <div class="vx-col w-full">

          </div>
        </div>



        <div class="vx-row mb-3 mt-4">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="company_name" name="company_name" rules="required" v-slot="{ errors }">
              <small class="label">Company Name</small>
              <vs-input :disabled="isFieldDisabled"  readonly type="text" name="company_name" class="w-full" v-model="form.company_name"/>
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="parent_company_name" name="parent_company_name" rules="" v-slot="{ errors }">
              <small class="label">Parent Company Name</small>
              <vs-input :disabled="isFieldDisabled"  type="text" name="parent_company_name" class="w-full" v-model="form.parent_company_name"/>
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="email" name="email" rules="email" v-slot="{ errors }">
              <small class="label">Company General Email</small>
              <vs-input :disabled="isFieldDisabled"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                        type="text" name="email" class="w-full" v-model="form.email"/>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="alternative_email" name="alternative_email" rules="email" v-slot="{ errors }">
              <small class="label">Alternate Company Email</small>
              <vs-input :disabled="isFieldDisabled"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                        type="text" name="alternative_email" class="w-full" v-model="form.alternative_email"/>
            </ValidationProvider>
            <!--            <ValidationProvider vid="country" name="country" rules="required" v-slot="{ errors }">-->
            <!--              <small class="label">Country</small>-->
            <!--              <v-select :disabled="isFieldDisabled"  :filter-by="myFilter" :clearable="false" name="country" placeholder="" label="name"-->
            <!--                        v-model="form.country" :reduce="option => option.name" :options="countryCodes"-->
            <!--                        :dir="$vs.rtl ? 'rtl' : 'ltr'">-->
            <!--                <template v-slot:option="option">-->
            <!--                  <span>{{option.name}} </span>-->
            <!--                </template>-->
            <!--              </v-select>-->
            <!--              <span class="text-danger text-sm">{{ errors[0] }}</span>-->
            <!--            </ValidationProvider>-->
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <div class="vx-row">
              <div class="vx-col w-1/3">
                <ValidationProvider vid="country_code_main_telephone" name="country_code_main_telephone" rules="required"
                                    v-slot="{ errors }">
                  <small class="label">Country Code</small>
                  <v-select :disabled="isFieldDisabled"  class="style-chooser" :filter-by="myFilter" :clearable="false" name="country_code_main_telephone" placeholder=""
                            label="isd_code" v-model="form.country_code_main_telephone" :reduce="option => option.isd_code"
                            :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                    <template v-slot:option="option">
                      <span>{{option.isd_code}} - {{option.name}} </span>
                    </template>
                  </v-select>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col w-2/3">
                <ValidationProvider vid="main_telephone" name="main_telephone" rules="required|tel|max:15" v-slot="{ errors }">
                  <small class="label">Main Telephone</small>
                  <vs-input :disabled="isFieldDisabled"  name="main_telephone" class="w-full required" label="" v-model="form.main_telephone"
                            :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                            val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <div class="vx-row">
              <div class="vx-col w-1/3">
                <ValidationProvider vid="country_code_secondary_telephone" name="country_code_secondary_telephone" rules="" v-slot="{ errors }">
                  <small class="label">Country Code</small>
                  <v-select :disabled="isFieldDisabled"  :filter-by="myFilter" :clearable="false" name="country_code_secondary_telephone" placeholder=""
                            label="isd_code" v-model="form.country_code_secondary_telephone" :reduce="option => option.isd_code"
                            :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                    <template v-slot:option="option">
                      <span>{{option.isd_code}} - {{option.name}} </span>
                    </template>
                  </v-select>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col w-2/3">
                <ValidationProvider vid="secondary_telephone" name="secondary_telephone" rules="" v-slot="{ errors }">
                  <small class="label">Secondary Telephone</small>
                  <vs-input :disabled="isFieldDisabled"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                            val-icon-pack="feather" type="text" name="secondary_telephone" class="w-full" v-model="form.secondary_telephone"/>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <div class="vx-row">
              <div class="vx-col w-1/3">
                <ValidationProvider vid="country_code_fax" name="country_code_fax" rules="" v-slot="{ errors }">
                  <small class="label">Country Code</small>
                  <v-select :disabled="isFieldDisabled"  :filter-by="myFilter" :clearable="false" name="country_code_fax" placeholder=""
                            label="isd_code" v-model="form.country_code_fax" :reduce="option => option.isd_code"
                            :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                    <template v-slot:option="option">
                      <span>{{option.isd_code}} - {{option.name}} </span>
                    </template>
                  </v-select>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col w-2/3">
                <ValidationProvider vid="fax" name="fax" rules="" v-slot="{ errors }">
                  <small class="label">Fax</small>
                  <vs-input :disabled="isFieldDisabled"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                            val-icon-pack="feather" type="text" name="fax" class="w-full" v-model="form.fax"/>
                </ValidationProvider>
              </div>
            </div>
          </div>
<!--          <div class="vx-col md:w-1/2 w-full md:mb-0">-->
<!--            <ValidationProvider vid="source" name="source" rules="email" v-slot="{ errors }">-->
<!--              <small class="label">Source</small>-->
<!--              <vs-input :disabled="isFieldDisabled"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"-->
<!--                        type="text" name="source" class="w-full" v-model="form.source"/>-->
<!--            </ValidationProvider>-->
<!--          </div>-->
        </div>

        <!--        social account section start-->
<!--        <vs-divider class="mt-8 mb-12" color="primary" position="center">Social Accounts</vs-divider>-->
        <vx-card titleColor="#736F6E" title="Social Accounts" class="my-8" no-shadow>
          <vs-row vs-w="12" class="mt-8">
          <vs-col v-for="(social, index_contact) in form.social_accounts" :key="index_contact"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="6" vs-sm="6" vs-xs="12"
                  class="px-4 pb-4">
            <vx-card-custom :cardBorder="true" no-shadow  v-on:remove="deleteSocialAccount(index_contact)" :remove-card-action="true"  :collapse-action="false">
              <div class="vx-row mb-2">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider  :vid="index_contact+'type'" :name="index_contact+'type'" rules="required" v-slot="{ errors }">
                    <small class="label">Type</small>
                    <v-select :disabled="isFieldDisabled"   :clearable="false" name="type" placeholder="" v-model="social.type" :options="socialMediaList" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider  :vid="index_contact+'url'" :name="index_contact+'url'" rules="required" v-slot="{ errors }">
                    <small class="label">URL</small>
                    <vs-input :disabled="isFieldDisabled"  type="text" v-model="social.url" name="url" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
              </div>

            </vx-card-custom>
          </vs-col>
        </vs-row>
          <vs-button :disabled="isFieldDisabled"  class="mt-4 mb-4 ml-4" @click="addSocialAccount" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus">Add social account</vs-button>
        </vx-card>
        <!--        social account section end-->


        <div class="vx-row mb-3 mt-4">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="nature_of_business" name="nature_of_business" rules="required" v-slot="{ errors }">
              <small class="label">Nature of Business</small>
              <vs-input :disabled="isFieldDisabled"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                        val-icon-pack="feather" type="text" name="nature_of_business" class="w-full" v-model="form.nature_of_business"/>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="website" name="website" rules="" v-slot="{ errors }">
              <small class="label">Web site</small>
              <vs-input :disabled="isFieldDisabled"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                        type="text" name="email" class="w-full" v-model="form.website"/>
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="date_trade_commenced" name="date_trade_commenced" rules="required" v-slot="{ errors }">
              <small class="label">Date Trade Commenced</small>
              <!--              <vs-input :disabled="isFieldDisabled"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"-->
              <!--                        val-icon-pack="feather" type="text" name="date_trade_commenced" class="w-full" v-model="form.date_trade_commenced"/>-->

              <flat-pickr :disabled="isFieldDisabled"  class="hidden  " :config="{ dateFormat: 'd/m/Y'}" v-model="form.date_trade_commenced" placeholder="Choose Date"/>
              <flat-pickr :disabled="isFieldDisabled"  class="w-full" :config="{ dateFormat: 'd/m/Y'}" v-model="form.date_trade_commenced" placeholder="Choose Date"/>
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="credit_required_per_month" name="credit_required_per_month" rules="required" v-slot="{ errors }">
              <small class="label">Credit Required Per Month</small>
              <vs-input :disabled="isFieldDisabled"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                        type="text" name="credit_required_per_month" class="w-full" v-model="form.credit_required_per_month"/>
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mb-3 mt-4">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="eori" name="eori" rules="" v-slot="{ errors }">
              <small class="label">EORI Number </small>
              <vs-input :disabled="isFieldDisabled"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                        val-icon-pack="feather" type="text" name="eori" class="w-full" v-model="form.eori"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col w-full">
            <ValidationProvider vid="description" name="description" rules="" v-slot="{ errors }">
              <small class="label">Additional Information</small>
              <vs-textarea :disabled="isFieldDisabled"  class="mb-0" v-model="form.additional_information" height="100px" />
              <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/5 md:mb-0">
            <ValidationProvider vid="is_vat_registration" name="is_vat_registration" rules="" v-slot="{ errors }">
              <small class="label">Do you have a Company VAT Registration?</small>
              <vs-switch :disabled="isFieldDisabled"  v-model="form.is_vat_registration" icon-pack="feather" vs-icon-on="icon-check-circle"
                         vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col w-2/5">
            <ValidationProvider v-if="form.is_vat_registration" vid="is_vat_registration_country"
                                name="is_vat_registration_country" rules="required" v-slot="{ errors }">
              <small class="label">If Yes, In which country are you registered?</small>
              <v-select :disabled="isFieldDisabled"  :filter-by="myFilter" :clearable="false" name="is_vat_registration_country" placeholder=""
                        label="name" v-model="form.is_vat_registration_country" :reduce="option => option.name"
                        :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-2/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_vat_registration" vid="is_vat_registration_text"
                                name="is_vat_registration_text" rules="required" v-slot="{ errors }">
              <small class="label">If Yes, Company VAT Registration?</small>
              <vs-input :disabled="isFieldDisabled"  type="text" name="is_vat_registration_text" class="w-full"
                        v-model="form.is_vat_registration_text"/>
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/5 md:mb-0">
            <ValidationProvider vid="is_registration" name="is_registration" rules="" v-slot="{ errors }">
              <small class="label">Do you have a Company Registration Number?</small>
              <vs-switch :disabled="isFieldDisabled"  v-model="form.is_registration" icon-pack="feather" vs-icon-on="icon-check-circle"
                         vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col w-2/5">
            <ValidationProvider v-if="form.is_registration" vid="is_registration_country" name="is_registration_country"
                                rules="required" v-slot="{ errors }">
              <small class="label">If Yes, In which country are you registered</small>
              <v-select :disabled="isFieldDisabled"  :filter-by="myFilter" :clearable="false" name="is_registration_country" placeholder=""
                        label="name" v-model="form.is_registration_country" :reduce="option => option.name"
                        :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-2/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_registration" vid="is_registration_text" name="is_registration_text"
                                rules="required" v-slot="{ errors }">
              <small class="label">If Yes, Company Registration Number</small>
              <vs-input :disabled="isFieldDisabled"  type="text" name="is_registration_text" class="w-full" v-model="form.is_registration_text"/>
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>


        <!--        contacts section start-->
<!--        <vs-divider class="mt-8 mb-12" color="primary" position="center">Contacts</vs-divider>-->
        <vx-card titleColor="#736F6E" title="Contacts" class="my-8" no-shadow>
          <vs-row vs-w="12" class="mt-8">
          <vs-col v-for="(contact, index_contact) in form.contacts" :key="index_contact"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="6" vs-sm="6" vs-xs="12"
                  class="px-4 pb-4">
            <vx-card-custom :cardBorder="true" no-shadow  v-on:remove="deleteContact(index_contact)" :remove-card-action="![0, 1, 2].includes(index_contact)"  :collapse-action="false">

              <div class="vx-row mb-2">
                <div class="vx-col md:w-full w-full md:mb-0">
                  <ValidationProvider :vid="index_contact+'type'" :name="index_contact+'type'" rules="required" v-slot="{ errors }">
                    <small class="label">Contact Type</small>
                    <v-select :disabled="isFieldDisabled"  :filter-by="myFilter"  :clearable="false" name="country" placeholder="" label="name" v-model="contact.type" :reduce="option => option.value" :options="contacts_types" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                      <template v-slot:option="option">
                        <span>{{option.name}} </span>
                      </template>
                    </v-select>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>


              <div class="vx-row mb-2">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider  :vid="index_contact+'contact_name'" :name="index_contact+'contact_name'" rules="required" v-slot="{ errors }">
                    <small class="label">Contact Name</small>
                    <vs-input :disabled="isFieldDisabled"  type="text" v-model="contact.contact_name" name="line1" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider  :vid="index_contact+'email'" :name="index_contact+'email'" rules="required" v-slot="{ errors }">
                    <small class="label">Contact Email</small>
                    <vs-input :disabled="isFieldDisabled"  type="text" v-model="contact.email" name="email" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
              </div>

              <div class="vx-row mb-2">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider :vid="index_contact+'country_code_telephone'" :name="index_contact+'country_code_telephone'" rules="required" v-slot="{ errors }">
                    <small class="label">Country Code</small>
                    <v-select :disabled="isFieldDisabled"  :filter-by="myFilter" :clearable="false" name="country_code_telephone" placeholder=""
                              label="isd_code" v-model="contact.country_code_telephone" :reduce="option => option.isd_code"
                              :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                      <template v-slot:option="option">
                        <span>{{option.isd_code}} - {{option.name}} </span>
                      </template>
                    </v-select>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider :vid="index_contact+'telephone'" :name="index_contact+'telephone'" rules="required" v-slot="{ errors }">
                    <small class="label">Telephone</small>
                    <vs-input :disabled="isFieldDisabled"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                              val-icon-pack="feather" type="text" name="telephone" class="w-full" v-model="contact.telephone"/>
                  </ValidationProvider>
                </div>
              </div>



            </vx-card-custom>
          </vs-col>
        </vs-row>
          <vs-button :disabled="isFieldDisabled"  class="mt-4 mb-4 ml-4" @click="addContact" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus">Add new contact</vs-button>
        </vx-card>
        <!--        contacts section end-->



        <!--        main address section start-->
<!--        <vs-divider class="mt-8 mb-12" color="primary" position="center">Main Address</vs-divider>-->
        <vx-card titleColor="#736F6E" title="Main Address" class="my-8" no-shadow>
          <vs-row vs-w="12" class="mt-8">
          <vs-col v-for="(address, index_address) in form.addresses" :key="index_address"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="6" vs-sm="6" vs-xs="12"
                  class="px-4 pb-4">
            <vx-card-custom :cardBorder="true" no-shadow  v-on:remove="deleteMainAddresses(index_address)" :remove-card-action="form.addresses.length !== 1"  :collapse-action="false">
              <div class="vx-row mb-2 w-full">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider  :vid="index_address+'line1'" :name="index_address+'line1'" rules="required" v-slot="{ errors }">
                    <small class="label">Address Line 1</small>
                    <vs-input :disabled="isFieldDisabled"  type="text" v-model="address.line1" name="line1" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider  :vid="index_address+'line2'" :name="index_address+'line2'" rules="" v-slot="{ errors }">
                    <small class="label">Address Line 2</small>
                    <vs-input :disabled="isFieldDisabled"  type="text" v-model="address.line2" name="line2" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
              </div>

              <div class="vx-row mb-2 w-full">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider  :vid="index_address+'line3'" :name="index_address+'line3'" rules="" v-slot="{ errors }">
                    <small class="label">Address Line 3</small>
                    <vs-input :disabled="isFieldDisabled"  type="text" v-model="address.line3" name="line3" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider  :vid="index_address+'town_state'" :name="index_address+'town_state'" rules="required" v-slot="{ errors }">
                    <small class="label">Name of Town / State</small>
                    <vs-input :disabled="isFieldDisabled"  type="text" v-model="address.town_state" name="town_state" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
              </div>

              <div class="vx-row mb-2 w-full">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider  :vid="index_address+'post_code'" :name="index_address+'post_code'" rules="required" v-slot="{ errors }">
                    <small class="label">Postal code</small>
                    <vs-input :disabled="isFieldDisabled"  type="text" v-model="address.post_code" name="post_code" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider :vid="index_address+'country'" :name="index_address+'country'" rules="required" v-slot="{ errors }">
                    <small class="label">Country</small>
                    <v-select :disabled="isFieldDisabled"  :filter-by="myFilter"  :clearable="false" name="country" placeholder="" label="name" v-model="address.country" :reduce="option => option.name" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                      <template v-slot:option="option">
                        <span>{{option.name}} </span>
                      </template>
                    </v-select>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>

              <div class="vx-row mb-2 w-full">
                <div class="vx-col md:w-full w-full md:mb-0">
                  <ValidationProvider  :vid="index_address+'note'" :name="index_address+'note'" rules="" v-slot="{ errors }">
                    <small class="label">Any Note</small>
                    <vs-input :disabled="isFieldDisabled"  type="text" v-model="address.note" name="note" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
              </div>

            </vx-card-custom>
          </vs-col>
        </vs-row>
<!--          <vs-button :disabled="isFieldDisabled"  class="mt-4 mb-4 ml-4" @click="addMainAddress" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus">Add new address</vs-button>-->
        </vx-card>
        <!--        main address section end-->

        <!--        delivery address section start-->
<!--        <vs-divider v-if="!form.delivery_address_same_as_above" class="mt-8 mb-12" color="primary" position="center">Delivery Address</vs-divider>-->

        <vx-card titleColor="#736F6E" title="Delivery Address" class="my-8" no-shadow>
          <div class="vx-row mb-3 mt-4">
          <div class="vx-col md:w-full md:mb-0">
            <ValidationProvider vid="invoice_address_same_as_above" name="invoice_address_same_as_above" rules="" v-slot="{ errors }">
              <small class="label">Is Delivery Address Same as Above?</small>
              <vs-switch :disabled="isFieldDisabled"  v-model="form.delivery_address_same_as_above" icon-pack="feather" vs-icon-on="icon-check-circle"
                         vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
        </div>

          <vs-row v-if="!form.delivery_address_same_as_above"  vs-w="12" class="mt-8">
          <vs-col v-for="(address, index_address) in form.delivery_address" :key="index_address"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="6" vs-sm="6" vs-xs="12"
                  class="px-4 pb-4">
            <vx-card-custom :cardBorder="true" no-shadow  v-on:remove="deleteDeliveryAddresses(index_address)" :remove-card-action="form.delivery_address.length !== 1"  :collapse-action="false">
              <div class="vx-row mb-2 w-full">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider  :vid="index_address+'delivery_address_line1'" :name="index_address+'delivery_address_line1'" rules="required" v-slot="{ errors }">
                    <small class="label">Address Line 1</small>
                    <vs-input :disabled="isFieldDisabled"  type="text" v-model="address.line1" name="line1" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider  :vid="index_address+'delivery_address_line2'" :name="index_address+'delivery_address_line2'" rules="" v-slot="{ errors }">
                    <small class="label">Address Line 2</small>
                    <vs-input :disabled="isFieldDisabled"  type="text" v-model="address.line2" name="line2" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
              </div>

              <div class="vx-row mb-2 w-full">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider  :vid="index_address+'delivery_address_line3'" :name="index_address+'delivery_address_line3'" rules="" v-slot="{ errors }">
                    <small class="label">Address Line 3</small>
                    <vs-input :disabled="isFieldDisabled"  type="text" v-model="address.line3" name="line3" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider  :vid="index_address+'delivery_address_town_state'" :name="index_address+'delivery_address_town_state'" rules="required" v-slot="{ errors }">
                    <small class="label">Name of Town / State</small>
                    <vs-input :disabled="isFieldDisabled"  type="text" v-model="address.town_state" name="town_state" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
              </div>

              <div class="vx-row mb-2 w-full">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider  :vid="index_address+'delivery_address_post_code'" :name="index_address+'delivery_address_post_code'" rules="required" v-slot="{ errors }">
                    <small class="label">Postal code</small>
                    <vs-input :disabled="isFieldDisabled"  type="text" v-model="address.post_code" name="post_code" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider :vid="index_address+'delivery_address_country'" :name="index_address + 'delivery_address_country'" rules="required" v-slot="{ errors }">
                    <small class="label">Country</small>
                    <v-select :disabled="isFieldDisabled"  :filter-by="myFilter"  :clearable="false" name="country" placeholder="" label="name" v-model="address.country" :reduce="option => option.name" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                      <template v-slot:option="option">
                        <span>{{option.name}} </span>
                      </template>
                    </v-select>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>

              <div class="vx-row mb-2 w-full">
                <div class="vx-col md:w-full w-full md:mb-0">
                  <ValidationProvider  :vid="index_address+'delivery_address_note'" :name="index_address+'delivery_address_note'" rules="" v-slot="{ errors }">
                    <small class="label">Any Note</small>
                    <vs-input :disabled="isFieldDisabled"  type="text" v-model="address.note" name="note" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
              </div>

            </vx-card-custom>
          </vs-col>
        </vs-row>
          <vs-button :disabled="isFieldDisabled"  v-if="!form.delivery_address_same_as_above"  class="mt-4 mb-4 ml-4" @click="addDeliveryAddress" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus">Add new address</vs-button>
        </vx-card>
        <!--      delivery address section end-->

        <!--        invoice address section start-->
<!--        <vs-divider v-if="!form.invoice_address_same_as_above" class="mt-8 mb-12" color="primary" position="center">Invoice Address</vs-divider>-->

        <vx-card titleColor="#736F6E" title="Invoice Address" class="my-8" no-shadow>
          <div class="vx-row mb-3 mt-4">
          <div class="vx-col md:w-full md:mb-0">
            <ValidationProvider vid="invoice_address_same_as_above" name="invoice_address_same_as_above" rules="" v-slot="{ errors }">
              <small class="label">Is Invoice Address Same as Above?</small>
              <vs-switch :disabled="isFieldDisabled"  v-model="form.invoice_address_same_as_above" icon-pack="feather" vs-icon-on="icon-check-circle"
                         vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
        </div>

          <vs-row v-if="!form.invoice_address_same_as_above"  vs-w="12" class="mt-8">
          <vs-col v-for="(address, index_address) in form.invoice_address" :key="index_address"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="6" vs-sm="6" vs-xs="12"
                  class="px-4 pb-4">
            <vx-card-custom :cardBorder="true" no-shadow  v-on:remove="deleteInvoiceAddresses(index_address)" :remove-card-action="form.invoice_address.length !== 1"  :collapse-action="false">
              <div class="vx-row mb-2 w-full">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider  :vid="index_address+'invoice_address_line1'" :name="index_address+'invoice_address_line1'" rules="required" v-slot="{ errors }">
                    <small class="label">Address Line 1</small>
                    <vs-input :disabled="isFieldDisabled"  type="text" v-model="address.line1" name="line1" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider  :vid="index_address+'invoice_address_line2'" :name="index_address+'invoice_address_line2'" rules="" v-slot="{ errors }">
                    <small class="label">Address Line 2</small>
                    <vs-input :disabled="isFieldDisabled"  type="text" v-model="address.line2" name="line2" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
              </div>

              <div class="vx-row mb-2 w-full">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider  :vid="index_address+'invoice_address_line3'" :name="index_address+'invoice_address_line3'" rules="" v-slot="{ errors }">
                    <small class="label">Address Line 3</small>
                    <vs-input :disabled="isFieldDisabled"  type="text" v-model="address.line3" name="line3" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider  :vid="index_address+'invoice_address_town_state'" :name="index_address+'invoice_address_town_state'" rules="required" v-slot="{ errors }">
                    <small class="label">Name of Town / State</small>
                    <vs-input :disabled="isFieldDisabled"  type="text" v-model="address.town_state" name="town_state" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
              </div>

              <div class="vx-row mb-2 w-full">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider  :vid="index_address+'invoice_address_post_code'" :name="index_address+'invoice_address_post_code'" rules="required" v-slot="{ errors }">
                    <small class="label">Postal code</small>
                    <vs-input :disabled="isFieldDisabled"  type="text" v-model="address.post_code" name="post_code" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider :vid="index_address+'invoice_address_country'" :name="index_address + 'invoice_address_country'" rules="required" v-slot="{ errors }">
                    <small class="label">Country</small>
                    <v-select :disabled="isFieldDisabled"  :filter-by="myFilter"  :clearable="false" name="country" placeholder="" label="name" v-model="address.country" :reduce="option => option.name" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                      <template v-slot:option="option">
                        <span>{{option.name}} </span>
                      </template>
                    </v-select>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>

              <div class="vx-row mb-2 w-full">
                <div class="vx-col md:w-full w-full md:mb-0">
                  <ValidationProvider  :vid="index_address+'invoice_address_note'" :name="index_address+'invoice_address_note'" rules="" v-slot="{ errors }">
                    <small class="label">Any Note</small>
                    <vs-input :disabled="isFieldDisabled"  type="text" v-model="address.note" name="note" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
              </div>

            </vx-card-custom>
          </vs-col>
        </vs-row>
          <vs-button :disabled="isFieldDisabled"  v-if="!form.invoice_address_same_as_above"  class="mt-4 mb-4 ml-4" @click="addInvoiceAddress" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus">Add new address</vs-button>
        </vx-card>
        <!--      invoice address section end-->

        <div class="vx-row mb-3 mt-4">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="special_delivery_instruction" name="special_delivery_instruction" rules="" v-slot="{ errors }">
              <small class="label">Special Delivery Instruction</small>
              <vs-textarea :disabled="isFieldDisabled"   class="mb-0" v-model="form.special_delivery_instruction" />
              <span class="text-danger mt-0 text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="additional_information" name="additional_information" rules="" v-slot="{ errors }">
              <small class="label">Additional Information</small>
              <vs-textarea :disabled="isFieldDisabled"   class="mb-0" v-model="form.additional_information" />
              <span class="text-danger mt-0 text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>

        <!--        bank details section start-->
        <vx-card class="my-8" no-shadow titleColor="#736F6E" title="Bank Reference">
          <div class="vx-row mb-8">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="bank" name="bank" rules="required" v-slot="{ errors }">
                <small class="label">Bank Name</small>
                <vs-input :disabled="isFieldDisabled"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                          val-icon-pack="feather" type="text" name="bank" class="w-full" v-model="form.bank"/>
              </ValidationProvider>
            </div>
          </div>

          <span>Bank Address</span>

          <div class="vx-row mb-2 mt-4">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider  vid="bank_address_line1" name="bank_address_line1" rules="required" v-slot="{ errors }">
                <small class="label">Address Line 1</small>
                <vs-input :disabled="isFieldDisabled"  type="text" v-model="form.bank_address.line1" name="line1" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider  vid="bank_address_line2" name="bank_address_line2" rules="" v-slot="{ errors }">
                <small class="label">Address Line 2</small>
                <vs-input :disabled="isFieldDisabled"  type="text" v-model="form.bank_address.line2" name="line2" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider  vid="bank_address_line3" name="bank_address_line3" rules="" v-slot="{ errors }">
                <small class="label">Address Line 3</small>
                <vs-input :disabled="isFieldDisabled"  type="text" v-model="form.bank_address.line3" name="line3" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider  vid="bank_address_town_state" name="bank_address_town_state" rules="required" v-slot="{ errors }">
                <small class="label">Name of Town / State</small>
                <vs-input :disabled="isFieldDisabled"  type="text" v-model="form.bank_address.town_state" name="town_state" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider  vid="bank_address_post_code" name="bank_address_post_code" rules="required" v-slot="{ errors }">
                <small class="label">Postal code</small>
                <vs-input :disabled="isFieldDisabled"  type="text" v-model="form.bank_address.post_code" name="post_code" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="bank_address_country" name="bank_address_country" rules="required" v-slot="{ errors }">
                <small class="label">Country</small>
                <v-select :disabled="isFieldDisabled"  :filter-by="myFilter"  :clearable="false" name="country" placeholder="" label="name" v-model="form.bank_address.country" :reduce="option => option.name" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{option.name}} </span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
        </vx-card>
        <!--        bank details section end-->

        <div class="vx-row mb-2">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="type_of_company" name="type_of_company" rules="required" v-slot="{ errors }">
              <small class="label">Type of Company</small>
              <v-select :disabled="isFieldDisabled"  :filter-by="myFilter"  :clearable="false" name="type_of_company" placeholder="" label="name" v-model="form.type_of_company" :reduce="option => option.value" :options="company_types" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                <template v-slot:option="option">
                  <span>{{option.name}} </span>
                </template>
              </v-select>
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>

        <!--        solo partnership section start-->
        <vs-row v-if="['sole_trader', 'partnership'].includes(form.type_of_company)" vs-w="12" class="mt-8">
          <vs-col v-for="(sole, index_address) in form.sole_partnerships" :key="index_address"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="6" vs-sm="6" vs-xs="12"
                  class="px-4 pb-4">
            <vx-card-custom :cardBorder="true" no-shadow  v-on:remove="deleteSolePartnership(index_address)" :remove-card-action="form.sole_partnerships.length !== 1"  :collapse-action="false">

              <div class="vx-row mb-2">
                <div class="vx-col md:w-full w-full md:mb-0">
                  <ValidationProvider  :vid="index_address+'sole_full_name'" :name="index_address+'sole_full_name'" rules="required" v-slot="{ errors }">
                    <small class="label">{{form.type_of_company === 'partnership' ? "Partner\'s name" : "Sole trader\'s name"}}</small>
                    <vs-input :disabled="isFieldDisabled"  type="text" v-model="sole.full_name" name="full_name" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
              </div>

              <div class="vx-row mb-2">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider :vid="index_address+'sole_country_code_telephone'" :name="index_address+'sole_country_code_telephone'" rules="required" v-slot="{ errors }">
                    <small class="label">Country Code</small>
                    <v-select :disabled="isFieldDisabled"  :filter-by="myFilter" :clearable="false" name="country_code_telephone" placeholder=""
                              label="isd_code" v-model="sole.country_code_telephone" :reduce="option => option.isd_code"
                              :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                      <template v-slot:option="option">
                        <span>{{option.isd_code}} - {{option.name}} </span>
                      </template>
                    </v-select>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider :vid="index_address+'sole_telephone'" :name="index_address+'sole_telephone'" rules="required" v-slot="{ errors }">
                    <small class="label">Telephone</small>
                    <vs-input :disabled="isFieldDisabled"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                              val-icon-pack="feather" type="text" name="telephone" class="w-full" v-model="sole.telephone"/>
                  </ValidationProvider>
                </div>
              </div>

              <div class="vx-row mb-2">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider  :vid="index_address+'sole_line1'" :name="index_address+'sole_line1'" rules="required" v-slot="{ errors }">
                    <small class="label">Address Line 1</small>
                    <vs-input :disabled="isFieldDisabled"  type="text" v-model="sole.line1" name="line1" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider  :vid="index_address+'sole_line2'" :name="index_address+'sole_line2'" rules="" v-slot="{ errors }">
                    <small class="label">Address Line 2</small>
                    <vs-input :disabled="isFieldDisabled"  type="text" v-model="sole.line2" name="line2" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
              </div>

              <div class="vx-row mb-2">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider  :vid="index_address+'sole_line3'" :name="index_address+'sole_line3'" rules="" v-slot="{ errors }">
                    <small class="label">Address Line 3</small>
                    <vs-input :disabled="isFieldDisabled"  type="text" v-model="sole.line3" name="line3" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider  :vid="index_address+'sole_town_state'" :name="index_address+'sole_town_state'" rules="required" v-slot="{ errors }">
                    <small class="label">Name of Town / State</small>
                    <vs-input :disabled="isFieldDisabled"  type="text" v-model="sole.town_state" name="town_state" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
              </div>

              <div class="vx-row mb-2">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider  :vid="index_address+'sole_post_code'" :name="index_address+'sole_post_code'" rules="required" v-slot="{ errors }">
                    <small class="label">Postal code</small>
                    <vs-input :disabled="isFieldDisabled"  type="text" v-model="sole.post_code" name="post_code" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider :vid="index_address+'sole_country'" :name="index_address+'sole_country'" rules="required" v-slot="{ errors }">
                    <small class="label">Country</small>
                    <v-select :disabled="isFieldDisabled"  :filter-by="myFilter"  :clearable="false" name="country" placeholder="" label="name" v-model="sole.country" :reduce="option => option.name" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                      <template v-slot:option="option">
                        <span>{{option.name}} </span>
                      </template>
                    </v-select>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>

            </vx-card-custom>
          </vs-col>
        </vs-row>
        <vs-button :disabled="isFieldDisabled"  v-if="['sole_trader', 'partnership'].includes(form.type_of_company)" class="mt-4 mb-4 ml-4" @click="addSolePartnership" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus">
          {{form.type_of_company === 'partnership' ? "Add another partner into your account" : "Add another sole trader into your account"}}
        </vs-button>
        <!--        solo partnership section end-->




<!--        <vs-divider class="mt-8 mb-12" color="primary" position="center">Trade Reference</vs-divider>-->

        <!--        trade ref section start-->
        <vx-card titleColor="#736F6E" title="Trade Reference" class="my-8" no-shadow>
          <vs-row vs-w="12" class="mt-8">
          <vs-col v-for="(trade, index_address) in form.trade_reference" :key="index_address"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="6" vs-sm="6" vs-xs="12"
                  class="px-4 pb-4">
            <vx-card-custom :cardBorder="true" no-shadow  v-on:remove="deleteTradeRef(index_address)" :remove-card-action="true"  :collapse-action="false">

              <div class="vx-row mb-2">
                <div class="vx-col md:w-full w-full md:mb-0">
                  <ValidationProvider  :vid="index_address+'trade_reference_name'" :name="index_address+'trade_reference_name'" rules="required" v-slot="{ errors }">
                    <small class="label">Reference Name</small>
                    <vs-input :disabled="isFieldDisabled"  type="text" v-model="trade.reference_name" name="reference_name" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
              </div>

              <div class="vx-row mb-2">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider  :vid="index_address+'trade_line1'" :name="index_address+'trade_line1'" rules="required" v-slot="{ errors }">
                    <small class="label">Address Line 1</small>
                    <vs-input :disabled="isFieldDisabled"  type="text" v-model="trade.line1" name="line1" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider  :vid="index_address+'trade_line2'" :name="index_address+'trade_line2'" rules="" v-slot="{ errors }">
                    <small class="label">Address Line 2</small>
                    <vs-input :disabled="isFieldDisabled"  type="text" v-model="trade.line2" name="line2" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
              </div>

              <div class="vx-row mb-2">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider  :vid="index_address+'trade_line3'" :name="index_address+'trade_line3'" rules="" v-slot="{ errors }">
                    <small class="label">Address Line 3</small>
                    <vs-input :disabled="isFieldDisabled"  type="text" v-model="trade.line3" name="line3" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider  :vid="index_address+'trade_town_state'" :name="index_address+'trade_town_state'" rules="required" v-slot="{ errors }">
                    <small class="label">Name of Town / State</small>
                    <vs-input :disabled="isFieldDisabled"  type="text" v-model="trade.town_state" name="town_state" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
              </div>

              <div class="vx-row mb-2">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider  :vid="index_address+'trade_post_code'" :name="index_address+'trade_post_code'" rules="required" v-slot="{ errors }">
                    <small class="label">Postal code</small>
                    <vs-input :disabled="isFieldDisabled"  type="text" v-model="trade.post_code" name="post_code" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider :vid="index_address+'trade_country'" :name="index_address+'trade_country'" rules="required" v-slot="{ errors }">
                    <small class="label">Country</small>
                    <v-select :disabled="isFieldDisabled"  :filter-by="myFilter"  :clearable="false" name="country" placeholder="" label="name" v-model="trade.country" :reduce="option => option.name" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                      <template v-slot:option="option">
                        <span>{{option.name}} </span>
                      </template>
                    </v-select>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>

              <div class="vx-row mb-2">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider  :vid="index_address+'trade_contact_name'" :name="index_address+'trade_contact_name'" rules="required" v-slot="{ errors }">
                    <small class="label">Contact Name</small>
                    <vs-input :disabled="isFieldDisabled"  type="text" v-model="trade.contact_name" name="contact_name" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider  :vid="index_address+'trade_email'" :name="index_address+'trade_email'" rules="required" v-slot="{ errors }">
                    <small class="label">Email</small>
                    <vs-input :disabled="isFieldDisabled"  type="text" v-model="trade.email" name="email" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
              </div>

            </vx-card-custom>
          </vs-col>
        </vs-row>
          <vs-button :disabled="isFieldDisabled"  class="mt-4 mb-4 ml-4" @click="addTradeRef" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus">Add trade reference</vs-button>
        </vx-card>
        <!--        trade ref section end-->


<!--        <div class="vx-row mb-3">-->
<!--          <div class="vx-col md:w-1/3 w-full md:mb-0">-->
<!--            <small class="label">Upload Letter Head</small>-->
<!--            <file-uploader v-on:onSetFileName="value => form.letter_head = value" v-on:onClickFileRemove="form.letter_head = null" :file="form.letter_head" :condition="true"/>-->
<!--          </div>-->
<!--        </div>-->


        <!-- Save & Reset Button -->
        <div v-can="'edit-customer'" class="flex flex-wrap items-center justify-end">
          <vs-button  button="submit" class="ml-auto mt-2">Save Changes</vs-button>
          <!--          <vs-button :disabled="isFieldDisabled"  class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>-->
        </div>
      </vx-card>
    </form>
  </ValidationObserver>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory';
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from 'vue-select'

  const SupplierRepository = RepositoryFactory.get('supplier');
  const CustomerRepository = RepositoryFactory.get('customer');
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture');
  import Datepicker from 'vuejs-datepicker';
  import moment from 'moment'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import FileUploader from '@/components/shared/FileUploader'

  import store from '../../../store/store.js'



  function initialState() {
    return {
      contacts_types: [{name: 'Purchasing', value: 'purchasing'}, {name: 'Account Payable', value: 'account_payable'},  {name: 'Booking In', value: 'booking_in'}],
      company_types: [
        {name: 'Limited', value: 'limited'},
        {name: 'Sole Trader', value: 'sole_trader'},
        {name: 'Partnership', value: 'partnership'},
        {name: 'Public Service', value: 'public_service'},
        {name: 'Charity', value: 'charity'}
        ],
      form: {
        is_vat_registration: false,
        is_registration: false,
        invoice_address_same_as_above: false
      },
      countryCodes: [],
      socialMediaList: ['Facebook', 'Twitter', 'LinkedIn', 'Pinterest', 'Reddit', 'Instagram'],
      isFieldDisabled: true
    }
  }

  export default {
    mixins: [SuccessMessage, ErrorMessages],
    data() {
      return initialState()
    },
    components: {
      'v-select': vSelect,
      Datepicker,
      flatPickr,
      FileUploader
    },
    computed: {},
    methods: {
      async onClickPasswordChange() {
        let payload = this.form;
        this.$vs.loading();
        try {
          this.form.is_vat_registration =  this.form.is_vat_registration ? this.form.is_vat_registration : false
          this.form.is_registration =  this.form.is_registration ? this.form.is_registration : false

          this.form.delivery_address_same_as_above =  this.form.delivery_address_same_as_above ? this.form.delivery_address_same_as_above : false
          this.form.invoice_address_same_as_above =  this.form.invoice_address_same_as_above ? this.form.invoice_address_same_as_above : false

          this.form.delivery_address =  this.form.delivery_address_same_as_above ? [] : this.form.delivery_address
          this.form.invoice_address =  this.form.invoice_address_same_as_above ? [] :  this.invoice_address

          const change = await SupplierRepository.updateSupplierBasicDetails(payload);
          this.showSuccessMessage('Customer Profile Update Successfully!')
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()

      },

      myFilter: (option, label, search) => {
        let temp = search.toLowerCase();
        return option.name.toLowerCase().indexOf(temp) > -1 ||
          option.isd_code.toLowerCase().indexOf(temp) > -1
      },
      addMainAddress() {
        this.form.addresses.push({line1: '', line2: '', line3: '', town_state: '', post_code: '', country: '', type: 'main', note: ''})
      },
      deleteMainAddresses(index) {
        this.form.addresses.splice(index, 1)
      },
      addInvoiceAddress() {
        this.form.invoice_address.push({line1: '', line2: '', line3: '', town_state: '', post_code: '', country: '', type: 'invoice', note: ''})
      },
      deleteInvoiceAddresses(index) {
        this.form.invoice_address.splice(index, 1)
      },
      addDeliveryAddress() {
        this.form.delivery_address.push({line1: '', line2: '', line3: '', town_state: '', post_code: '', country: '', type: 'delivery', note: ''})
      },
      deleteDeliveryAddresses(index) {
        this.form.delivery_address.splice(index, 1)
      },
      initialContactsAdd() {
        this.form.contacts = [
          {contact_name: '', country_code_telephone: '', telephone: '', email: '', type: 'purchasing'},
          // {contact_name: '', country_code_telephone: '', telephone: '', email: '', type: 'account_payable'},
          // {contact_name: '', country_code_telephone: '', telephone: '', email: '', type: 'booking_in'}
        ]
      },
      addContact() {
        this.form.contacts.push({contact_name: '', country_code_telephone: '', telephone: '', email: '', type: 'purchasing'},)
      },
      deleteContact(index) {
        this.form.contacts.splice(index, 1)
      },
      addSolePartnership() {
        this.form.sole_partnerships.push({full_name: '', line1: '', line2: '', line3: '', town_state: '', post_code: '', country: '', country_code_telephone: '', telephone: ''})
      },
      deleteSolePartnership(index) {
        this.form.sole_partnerships.splice(index, 1)
      },
      addTradeRef() {
        this.form.trade_reference.push({reference_name: '', line1: '', line2: '', line3: '', town_state: '', post_code: '', country: '', contact_name: '', email: ''})
      },
      deleteTradeRef(index) {
        this.form.trade_reference.splice(index, 1)
      },
      addSocialAccount() {
        this.form.social_accounts.push({type: '', url: ''})
      },
      deleteSocialAccount(index) {
        this.form.social_accounts.splice(index, 1)
      },
      customerStatusColorFactory(id) {
        switch (id) {
          case 1:
            return 'warning';
          case 2:
            return 'warning';
          case 3:
            return 'warning';
          case 4:
            return 'warning';
          case 5:
            return 'warning';
          case 6:
            return 'primary';
          case 7:
            return 'primary';
          case 8:
            return 'danger';
          case 9:
            return 'danger';
          case 10:
            return 'danger';
        }
      },
      submitCustomerConfirm () {
        this.$vs.dialog({
          type: 'confirm',
          color: 'success',
          title: 'Confirm',
          text: 'Are you sure you wish to change the status?',
          accept: this.submitCustomer
        })
      },
      async submitCustomer() {
        this.$vs.loading()
        try {
          await CustomerRepository.submitCustomer()
          // await this.reloadStatus()
          this.showSuccessMessage('Customer status updated!')
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      checkIsDisabled() {
        const permissions = store.getters.permissions
        this.isFieldDisabled = !(permissions.find(permission => permission === 'edit-customer') !== undefined)
      }
    },
    async mounted() {
      this.$vs.loading();
      try {
        this.checkIsDisabled()
        const {data} = (await SupplierRepository.getBasicSupplierDetails()).data;
        this.countryCodes = (await SupplierManufactureRepository.getCountryCodes()).data.data;
        this.form = data;

        if (this.form.addresses.length === 0) {
          this.addMainAddress()
        }
        if (this.form.invoice_address.length === 0) {
          this.addInvoiceAddress()
        }
        if (this.form.delivery_address.length === 0) {
          this.addDeliveryAddress()
        }
        if (this.form.contacts.length === 0) {
          this.initialContactsAdd()
        }
        if (this.form.sole_partnerships.length === 0) {
          this.addSolePartnership()
        }
        if (this.form.bank_address.length === 0) {
          this.form.bank_address = {}
        }
        if (this.form.trade_reference.length === 0) {
          this.addTradeRef()
          // this.addTradeRef()
        }
        if (this.form.social_accounts.length === 0) {
          // this.addSocialAccount()
        }
      } catch (error) {
        this.convertAndNotifyError(error)
      }
      this.$vs.loading.close()
    }
  }
</script>

<style>

</style>
